<template>
  <v-tooltip top>
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        text
        :color="primaryColor ? 'primary' : ''"
        @click="action"
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        :disabled="disabled"
      >
        <component
          :is="icon"
          :size="size"
        />
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "IconButtonWithTooltip",
  inheritAttrs: false,

  props: {
    tooltip: { type: String, required: true },
    icon: { type: String, required: true },
    action: { type: Function, required: true },
    primaryColor: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    size: { type: Number, default: 20 },
  }
};
</script>